module.exports = __webpack_public_path__ + "static/media/logo@3x.8876d1f2.webp";